// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.ballet",
    name: "Ballet Crypto",
    homepage: "https://www.ballet.com",
    image_id: "fd46e96d-350d-4922-a4a9-b2bfe7c92400",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/id1474912942",
        android: "https://play.google.com/store/apps/details?id=com.balletcrypto",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "balletcrypto://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map